module.exports = __webpack_public_path__ + "img/New PACI Flow - New User AR - 12.4e8f0acc.png";